var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('el-tag',{attrs:{"effect":_vm.effect,"type":_vm.type}},[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }